<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="$t('contact.title2')"
        pace="6"
      >
        {{ $t('contact.content1') }}
      </base-info-card>

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessInfo',

    props: { dark: Boolean },

    data: () => ({
      business: [],
    }),
  }
</script>
